import type { QuoteWatermark } from "@forgepoint/shared";
import { cn } from "@/lib/utils";

/**
 * Diagonal page-wide word drawn over a rendered quote page. Repeats per page because the page loop mounts one per page.
 * fixed: for flowing layouts with no page wrapper — one mark centered in the viewport on screen, and Chromium repeats a fixed element on every printed page.
 */
export function PageWatermark({
  watermark,
  fixed = false,
}: {
  watermark: QuoteWatermark;
  fixed?: boolean;
}) {
  return (
    <div
      aria-hidden
      className={cn(
        "pointer-events-none inset-0 flex select-none items-center justify-center overflow-hidden",
        fixed ? "fixed z-50" : "absolute",
      )}
    >
      <span className="-rotate-45 text-[150px] font-black uppercase tracking-[0.2em] text-[#B80000] opacity-10">
        {watermark}
      </span>
    </div>
  );
}
